export type AiCaptainDealKind = 'coupon' | 'promotion';

export interface AiCaptainDealItem {
  id: string;
  kind: AiCaptainDealKind;
  code?: string;
  title: string;
  description?: string;
  discountLabel?: string;
  minAmount?: number;
  estimatedSavings?: number;
  applicable?: boolean;
  applied?: boolean;
  reason?: string;
  promoType?: string;
  category?: string;
}

export function normalizeAiCaptainDeal(raw: Record<string, unknown>): AiCaptainDealItem | null {
  const id = raw.id != null ? String(raw.id) : '';
  const kind = raw.kind === 'promotion' ? 'promotion' : raw.kind === 'coupon' ? 'coupon' : null;
  const title = raw.title != null ? String(raw.title).trim() : raw.code != null ? String(raw.code).trim() : '';
  if (!id || !kind || !title) return null;

  const deal: AiCaptainDealItem = {
    id,
    kind,
    title,
  };

  if (raw.code != null) deal.code = String(raw.code).trim();
  if (raw.description != null) deal.description = String(raw.description).trim();
  if (raw.discountLabel != null) deal.discountLabel = String(raw.discountLabel).trim();
  if (raw.minAmount != null && Number.isFinite(Number(raw.minAmount))) {
    deal.minAmount = Number(raw.minAmount);
  }
  if (raw.estimatedSavings != null && Number.isFinite(Number(raw.estimatedSavings))) {
    deal.estimatedSavings = Number(raw.estimatedSavings);
  }
  if (raw.applicable != null) deal.applicable = Boolean(raw.applicable);
  if (raw.applied != null) deal.applied = Boolean(raw.applied);
  if (raw.reason != null) deal.reason = String(raw.reason).trim();
  if (raw.promoType != null) deal.promoType = String(raw.promoType).trim();
  if (raw.category != null) deal.category = String(raw.category).trim();

  return deal;
}

export function formatDealMeta(deal: AiCaptainDealItem): string {
  const parts: string[] = [];
  if (deal.discountLabel) parts.push(deal.discountLabel);
  if (deal.minAmount != null && deal.minAmount > 0) {
    parts.push(`Min order ₹${Math.round(deal.minAmount)}`);
  }
  if (deal.applicable && deal.estimatedSavings != null && deal.estimatedSavings > 0) {
    parts.push(`Save ₹${Math.round(deal.estimatedSavings)}`);
  }
  if (deal.applicable === false && deal.reason) parts.push(deal.reason);
  return parts.join(' · ');
}
